import { render, staticRenderFns } from "./pt-com-header.vue?vue&type=template&id=467b7f28&"
import script from "./pt-com-header.vue?vue&type=script&lang=js&"
export * from "./pt-com-header.vue?vue&type=script&lang=js&"
import style0 from "./pt-com-header.vue?vue&type=style&index=0&id=467b7f28&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports